import { Button, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { clearGlobalError } from '../../../store/reducers/uiSlice';

const Error = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { globalError } = useAppSelector((state) => state.ui);

  const handleGoBack = () => {
    dispatch(clearGlobalError());
    navigate(`/documents${location.search}`);
  };

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>

      {globalError ? (
        <Typography
          variant="h5"
          color="text.secondary"
          fontWeight={600}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            textAlign: 'center',
            fontSize: { xs: '1.25rem', sm: '1.5rem' },
            wordBreak: 'break-word',
          }}
        >
          {globalError.message ?? 'An error occurred'}
        </Typography>
      ) : (
        <Typography
          variant="h5"
          color="text.secondary"
          fontWeight={600}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            textAlign: 'center',
            fontSize: { xs: '1.25rem', sm: '1.5rem' },
            wordBreak: 'break-word',
          }}
        >
          Something went wrong. Please click Go Back to continue
        </Typography>
      )}
      <Button
        fullWidth
        variant="contained"
        sx={{
          backgroundColor: '#00aa8f',
          borderRadius: '10px',
          textTransform: 'none',
          fontWeight: 700,
          width: '10rem',
          marginTop: '2rem',
          fontSize: {
            xs: '0.6rem',
            sm: '1.1rem',
          },
        }}
        onClick={handleGoBack}
      >

        GO BACK
      </Button>
    </div>
  );
};

export default Error;
